import {
	contentContainerSX,
	noVideoMsgContainerSX,
} from '@/components/blocks/VideoDisplay/styles/videoStyle';
import { MainVideoPlayer } from '@/components/blocks/VideoDisplay/VideoPlayer';
import { ThumbnailGallery } from '@/components/blocks/VideoDisplay/VideoThumbnailGallery';
import { useLocalization } from '@/data/Localization';
import { Attachment } from '@/data/types/Product';
import { getYoutubeId } from '@/utils/video';
import { Box, Typography } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { useVideoGallery } from '@/components/blocks/ProductDetails/context/VideoGalleryContext';

interface VideoPlayerGalleryProp {
	videos?: Attachment[];
	handleChangeVideo: (videoData: Attachment) => void;
	handlePrevVideo: () => void;
	handleNextVideo: () => void;
}

export const VideoPlayerGallery: FC<VideoPlayerGalleryProp> = ({
	videos,
	handleChangeVideo,
	handlePrevVideo,
	handleNextVideo,
}) => {
	const { NoVideoAvailable, InvalidVideoURL } = useLocalization('VideoPanel');
	const { actualVideo, setActualVideo } = useVideoGallery();

	useEffect(() => {
		if (videos) {
			if (videos.length > 0 && actualVideo === null) {
				setActualVideo(videos[0]);
			}
		}
	}, [videos, actualVideo, setActualVideo]);

	const actualVideoId = useMemo(() => {
		if (!actualVideo?.attachmentAssetPath || !actualVideo.attachmentAssetPath.includes('youtube')) {
			return null;
		}
		return getYoutubeId(actualVideo.attachmentAssetPath);
	}, [actualVideo]);

	if (!videos || videos.length === 0 || !actualVideo || !actualVideoId) {
		const message = !actualVideo ? NoVideoAvailable.t() : InvalidVideoURL.t();

		return (
			<Box sx={noVideoMsgContainerSX}>
				<Typography variant="body1">{message}</Typography>
			</Box>
		);
	}

	return (
		<Box sx={contentContainerSX}>
			<MainVideoPlayer videos={videos} handleChangeVideo={handleChangeVideo} />

			{videos.length > 1 ? (
				<ThumbnailGallery
					videos={videos}
					handleChangeVideo={handleChangeVideo}
					handlePrevVideo={handlePrevVideo}
					handleNextVideo={handleNextVideo}
				/>
			) : null}
		</Box>
	);
};
